import { ReactElement, useState } from "react";
import { Dialog } from "../../../modal/Dialog";
import { SharePricingDialogContent } from "./SharePricingDialogContent";
import { SharePricingDialogNavigation } from "./SharePricingDialogNavigation";
import {
  SharePricingDialogPage,
  SharePricingSource,
} from "./SharePricingDialogTypes";

export function SharePricingDialog({
  active,
  onDismiss,
  priceTierId,
  optionalPriceTierName,
  source,
}: {
  active: boolean;
  onDismiss: () => void;
  priceTierId?: number;
  optionalPriceTierName?: string;
  source: SharePricingSource;
}): ReactElement {
  const [priceTierName, setPriceTierName] = useState<string | undefined>(
    optionalPriceTierName,
  );
  const [prevOptionalPriceTierName, setPrevOptionalPriceTierName] = useState(
    optionalPriceTierName,
  );

  // Sync when the optional name prop changes (adjust state during render).
  if (optionalPriceTierName !== prevOptionalPriceTierName) {
    setPrevOptionalPriceTierName(optionalPriceTierName);
    setPriceTierName(optionalPriceTierName);
  }

  return (
    <Dialog
      active={active}
      onDismiss={onDismiss}
      initPage={
        priceTierId
          ? SharePricingDialogPage.PRICE_TIER_LINK
          : SharePricingDialogPage.PRICE_TIERS
      }
      fullHeight={true}
    >
      <SharePricingDialogNavigation
        onDismiss={onDismiss}
        priceTierId={priceTierId}
        priceTierName={priceTierName}
      />
      <SharePricingDialogContent
        setPriceTierName={setPriceTierName}
        optionalPriceTierId={priceTierId}
        source={source}
      />
    </Dialog>
  );
}
